import { Spinner } from '@classgo/ui';

import { useKitT } from '../i18n';
import { useWaking } from './waking-state';

/**
 * The visible state while the dev cluster resumes (ticket #73): a quiet bar instead of error
 * toasts, gone as soon as a request succeeds.
 */
export const WakingBanner = () => {
  const t = useKitT();
  const isWaking = useWaking();
  if (!isWaking) return null;
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-info-100 px-4 py-2 text-sm text-info-700"
    >
      <Spinner />
      {t('waking.title')}
    </div>
  );
};
